module.exports = __webpack_public_path__ + "static/img/about3.48b512b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/about3.png
// module id = vddt
// module chunks = 1